import React, { useState } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import UseTable from "../../components-react/UseTable";
import PaginationModified from "../../../data/PaginationModified";
import { dateFormat } from "../../../exports/GlobalFunctions";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";

const LeadLogs = ({ setFilterValues, allLogs, setAllLogs, sheetNTabsData }) => {
  const { watilogsLoading } = useSelector((state) => state.api);

  const [selectedSheet, setSelectedSheet] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const handleSheetClick = (sheetId) => {
    setSelectedTab("");

    if (selectedSheet === sheetId) {
      setSelectedSheet(null);
      setFilterValues((prevs) => ({
        ...prevs,
        sheet_id: "",
        tab_name: "",
      }));
    } else {
      setSelectedSheet(sheetId);
      setFilterValues((prevs) => ({
        ...prevs,
        sheet_id: sheetId,
        tab_name: "",
      }));
    }
  };

  const handleTabClick = (tabName) => {
    if (selectedTab === tabName) {
      setSelectedTab(null);
      setFilterValues((prevs) => ({
        ...prevs,
        tab_name: "",
      }));
    } else {
      setSelectedTab(tabName);
      setFilterValues((prevs) => ({
        ...prevs,
        tab_name: selectedTab === tabName ? null : tabName,
      }));
    }
  };

  function getPagination() {
    try {
      const pagination = allLogs.pagination ? allLogs.pagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  const columns = [
    {
      Header: "Sheet ID",
      accessor: "sheet_id",
      Cell: ({ value }) => {
        return (
          <span
            className="tb-data link"
            onClick={() => {
              setOpenModal(true);
              setModalContent(value);
            }}>
            view
            {/* {value || "-"} */}
          </span>
        );
      },
    },
    {
      Header: "User Name",
      accessor: "name",
      Cell: ({ value }) => {
        return <span className="tb-data">{value || "NA"}</span>;
      },
    },
    {
      Header: "User Mobile",
      accessor: "mobile",
      Cell: ({ value }) => {
        return <span className="tb-data">{value || "NA"}</span>;
      },
    },
    {
      Header: "Message",
      accessor: "message",
      Cell: ({ value }) => {
        return (
          <>
            {value?.length <= 30 ? (
              <span className="tb-data">{value}</span>
            ) : (
              <span
                className="tb-data"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  setOpenModal(true);
                  setModalContent(value);
                }}>
                {value?.substring(0, 30)} <b className="link">...Read More</b>
              </span>
            )}
          </>
        );
      },
    },
    {
      Header: "Tab Name",
      accessor: "tab_name",
      Cell: ({ value }) => {
        return (
          <span className="tb-data">
            {value ? value.replace(/_/g, " ") : "NA"}
          </span>
        );
      },
    },
    {
      Header: "Date Added",
      accessor: "date_added",
      Cell: ({ value }) => {
        return (
          <span className="tb-data minWidth90">
            {value ? dateFormat(value) : "NA"}
          </span>
        );
      },
    },
    // {
    //   Header: "Last Updated",
    //   accessor: "last_updated minWidth90",
    //   Cell: ({ value }) => {
    //     return (
    //       <span className="tb-data">{value ? dateFormat(value) : "NA"}</span>
    //     );
    //   },
    // },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 bold"
            style={{
              background: value === "active" ? "#B4E7B9" : "#F3DADA",
              color: value === "active" ? "#0A701B" : "#D90000",
            }}>
            {value || "NA"}
          </span>
        );
      },
    },
  ];

  return (
    <div className="fullWidthFlexCenter globalUseTableContainer mt15">
      <Modal
        isOpen={openModal}
        onRequestClose={() => setOpenModal(false)}
        contentLabel="Predefined Message Modal"
        ariaHideApp={false}>
        <div className="createNewCTOModalContainer discussionModalBriefContainer">
          <ModalHeadAndClose title=" " onClose={() => setOpenModal(false)} />

          <div className="discussionModalMessage mt30">
            <p className="message" style={{ textTransform: "initial" }}>
              {modalContent || "No Content Available"}
            </p>
          </div>
        </div>
      </Modal>

      <div className="sheetTableContainer mt-0">
        {selectedSheet && (
          <div className="sheetTabsColumn">
            <span className="sheetHeadname">Tabs</span>

            {sheetNTabsData
              .find((sheet) => sheet.sheet_id === selectedSheet)
              ?.tab_name.map((tab, index) => (
                <span
                  key={index}
                  className={`sheetName ${selectedTab === tab ? "active" : ""}`}
                  onClick={() => {
                    setSelectedTab(tab);
                    handleTabClick(tab);
                  }}>
                  {tab}
                </span>
              ))}
          </div>
        )}

        <div className="sheetsAndDatas">
          <div className="sheetIdsColumn">
            <span className="sheetHeadname">Sheet IDs</span>

            {sheetNTabsData?.map((sheet, index) => (
              <span
                key={index}
                className={`sheetName ${
                  selectedSheet === sheet?.sheet_id ? "active" : ""
                }`}
                onClick={() => handleSheetClick(sheet?.sheet_id)}>
                {sheet?.sheet_name ? sheet.sheet_name : `Sheet ${index + 1}`}
              </span>
            ))}
          </div>

          <div className="sheettable">
            {watilogsLoading ? (
              <ReactVortoxSpinner />
            ) : (
              <UseTable
                columns={columns || [{}]}
                data={allLogs.allLogsData}
                name="wati-logs"
              />
            )}

            <div className="customTablePaginationContainer">
              <PaginationModified
                isPage={allLogs.isPage}
                onChangePage={(value) =>
                  setAllLogs((prevData) => ({
                    ...prevData,
                    isPage: value,
                  }))
                }
                pagination={getPagination()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadLogs;
